import React, { memo, useState, useEffect } from 'react'
import { t } from 'i18next'
import {
  postLoginService,
  getLockersService,
  getSlotsByLockerService,
} from 'Api/services/cuartServices'

const Locker = ({
  onSelectPickupInLockers,
  onSelectLocker,
  onSelectSlot,
  showLocker,
  renderSelector,
}) => {
  const [openDropdown, setOpenDropdown] = useState({
    locker: false,
    slot: false,
  })
  const [isPickupInLockers, setIsPickupInLockers] = useState(false)
  const [lockers, setLockers] = useState([])
  const [slots, setSlots] = useState([])
  const [lockerIdSelected, setLockerIdSelected] = useState(null)
  const [slotSelected, setSloctSelected] = useState(null)

  const login = async () => {
    const token = await postLoginService()
    window.localStorage.setItem('autorizationCuart', token)
    setTimeout(() => {
      getLockers()
    }, 200)
  }

  const getLockers = async () => {
    const data = await getLockersService()
    setLockers(data.map(item => ({ ...item, Description: item.name })))
  }

  const getSlotsByLocker = async lockerId => {
    const data = await getSlotsByLockerService(lockerId)
    setSlots(
      data.map(item => {
        const slotNumber = !isNaN(Number(item.number))
          ? String(item.number).padStart(2, '0')
          : ''

        return {
          ...item,
          Description: `${item.slot_size?.name ?? ''} - ${slotNumber}`,
        }
      })
    )
  }

  const clearSelection = () => {
    setSlots([])
    setLockerIdSelected(null)
    setSloctSelected(null)
  }

  useEffect(() => {
    if (showLocker) {
      login()
      setIsPickupInLockers(false)
    } else {
      clearSelection()
    }
  }, [showLocker])

  useEffect(() => {
    onSelectPickupInLockers(isPickupInLockers)
    if (!isPickupInLockers) {
      clearSelection()
    }
  }, [isPickupInLockers])

  useEffect(() => {
    onSelectLocker(lockerIdSelected)
    if (lockerIdSelected) {
      getSlotsByLocker(lockerIdSelected.id)
      setSloctSelected(null)
    }
  }, [lockerIdSelected])

  useEffect(() => {
    onSelectSlot(slotSelected)
  }, [slotSelected])

  if (!showLocker) {
    return null
  }

  return (
    <div data-testid="container-locker-pickup">
      <div className="add-delivery-superior-margin">
        <span className="generic-address-title-text">
          {t('TABLE_SELL_ORDER_T.LOCKER.PICK_UP_LOCKER')}
        </span>
        <label className="margin-label-sell-method">
          <input
            type="radio"
            name="pickupInLockers"
            checked={isPickupInLockers}
            value="yes"
            onClick={() => {
              setIsPickupInLockers(true)
            }}
            data-testid="input-radio-locker-pickup-yes"
          />
          <span className="table-sell-order-option-span">
            {t('TABLE_SELL_ORDER_T.YES_SELECTED_OPTION')}
          </span>
        </label>
        <label className="margin-label-sell-method">
          <input
            type="radio"
            name="pickupInLockers"
            checked={!isPickupInLockers}
            value="no"
            onClick={() => {
              setIsPickupInLockers(false)
            }}
            data-testid="input-radio-locker-pickup-no"
          />
          <span className="table-sell-order-option-span">
            {t('TABLE_SELL_ORDER_T.NO_SELECTED_OPTION')}
          </span>
        </label>
      </div>
      {isPickupInLockers && (
        <>
          <div
            className="add-delivery-superior-margin"
            data-testid="container-locker-selection">
            {renderSelector({
              title: t('TABLE_SELL_ORDER_T.LOCKER.AVAILABLE_LOCKERS'),
              showState: openDropdown.locker,
              setShowState: state =>
                setOpenDropdown({
                  ...openDropdown,
                  locker: state,
                }),
              valueState: lockerIdSelected,
              setValueState: setLockerIdSelected,
              mappedInfo: lockers,
              controlValue: 'locker',
              showSearch: true,
            })}
          </div>
          <div
            className="add-delivery-superior-margin"
            data-testid="container-slot-selection">
            {renderSelector({
              title: t('TABLE_SELL_ORDER_T.LOCKER.CHOOSE_SLOT_BY_SIZE'),
              showState: openDropdown.slot,
              setShowState: state =>
                setOpenDropdown({
                  ...openDropdown,
                  slot: state,
                }),
              valueState: slotSelected,
              setValueState: setSloctSelected,
              mappedInfo: slots,
              controlValue: 'slot',
              showSearch: true,
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default memo(Locker)
